var LayoutView = (function (RoutedView) {
	return RoutedView.extend({
		el: '@layout',
		initialize: function () {
			this._displayRouter.subscribe(this._on, this);

			var spinner = new Spinner(spinnerConfig); //tbd: make wrapper
			var timeout = setTimeout(function (el) { spinner.spin(el); }, CheckoutSettings.spinnerTimeout, $('@baseContent')[0]);//tbd: cannot handle unauthorized user to hide spinner
			this.model.once('sync', function () {
				clearTimeout(timeout);
				spinner.stop();
			});
		},
		_on: function () {
			this.$el.scrollTop(0); //tbd: save and restore top position
		}
	});
})(RoutedView);
